module.exports = __webpack_public_path__ + "static/media/commerce.08822bb7.png";